import { FirestoreDetection } from '@trace/types';
import { useContext, useEffect, useState } from 'react';
import { firestore } from 'firebase/app';
import { AuthContextTrace } from '../Authenticate/AuthenticateTrace';

/**
 * The SDK detection is constantly updating, but there are times where we only
 * want to listen to the changes until the it has been seen otherwise it can
 * cause unnecessary renders.
 */
export default function useSDKDetectionUntilSeen(): FirestoreDetection | undefined {
  const {
    data: { appId },
  } = useContext(AuthContextTrace);
  const [detections, setDetections] = useState<FirestoreDetection | undefined>();

  /**
   * There's nothing to return if a snapshot listeners isn't setup.
   */
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!detections) {
      return firestore()
        .doc(`/detections/${appId}`)
        .onSnapshot((snapshot) => {
          const data = snapshot.data() as FirestoreDetection | undefined;

          if (data && data.firstSeen) {
            setDetections(data);
          }
        });
    }
  }, [appId, detections]);

  return detections;
}
